import React, { Component } from "react";
import { connect } from "react-redux";
import { cultivo } from "../actions";
import {Container, Col, Row, Table, Jumbotron, Button} from 'reactstrap';
import LogoFacebook from '../images/logo_facebook.png';
import LogoTwitter from '../images/logo_twitter.png';
import LogoCorreo from '../images/logo_correo.png';
import Header from "./share/Header";
import decode from 'jwt-decode';
import Loading from "./share/Loading";
import { FaRedo } from 'react-icons/fa';

class Home extends Component {

    constructor(props){
        super(props);
        this.state = {
            propietario: '-'
        }
    }

    componentDidMount() {
        this.getData();
    }

    getData(){
        let token = localStorage.getItem('token_cafe');
        let dataToken = decode(token);
        this.setState({propietario: dataToken.nombre_completo});
        this.props.getCultivo();
    }

    render(){
        const {data_cultivo, error, is_loading} = this.props;
        let correo = null;

        if(!!data_cultivo && !!data_cultivo[0].users_has_cultivos[0].user.correo){
            correo = `mailto:${!!data_cultivo[0].users_has_cultivos[0].user.correo}`;
        }

        if(is_loading === true){
            return <Loading/>;
        }

        if(error !== null){
            return (<Row className="mt-5">
                <Col md={{size: 6, offset: 3}}>
                    <Jumbotron fluid>
                        <Container fluid>
                            <h1>Error</h1>
                            <p className="lead">{error}</p>
                            <Col md="12" className="text-center">
                                <Button onClick={()=>this.getData()}>
                                    Refrescar <FaRedo/>
                                </Button>
                            </Col>
                        </Container>
                    </Jumbotron>
                </Col>
            </Row>);
        }

        return (
            <div>
                <Header/>
                <Container className='home pb-5'>
                    <Row>
                        <h1 className="tituloGeneral mt-4 mb-4 text-center w-100 font-italic font-weight-bold">General</h1>
                    </Row>
                    {
                        <Row className="">
                            <Col md={{size: 5, offset: 1}} sm={{size: 10, offset: 1}} xs={{size: 10, offset: 1}}>
                                <img className="imagenCultivo" src={(!!data_cultivo && !!data_cultivo[0].imagen) ? data_cultivo[0].imagen : ''} alt="Cultivo"/>
                            </Col>
                            <Col md={{size: 5}} sm={{size: 10, offset: 1}} xs={{size: 10, offset: 1}} className="generalidades">
                                {
                                    (!!data_cultivo && !!data_cultivo[0].descripcion) ?
                                        <h2 className="text-center mt-5">
                                            {data_cultivo[0].descripcion}
                                        </h2> :
                                        <h2 className="text-center mt-5">
                                            Generalidades
                                        </h2>
                                }
                                <Table className="mt-3">
                                    <tbody>
                                    <tr>
                                        <th>
                                            <h4>Ubicación:</h4>
                                        </th>
                                        <td>
                                            {
                                                (!!data_cultivo && !!data_cultivo[0].ubicacion) ?
                                                    <span>{data_cultivo[0].ubicacion}</span> : <span>-</span>
                                            }
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h4>Número de hectáreas:</h4>
                                        </th>
                                        <td>
                                            {
                                                (!!data_cultivo && !!data_cultivo[0].hectareas) ?
                                                    <span>{data_cultivo[0].hectareas}</span> : <span>-</span>
                                            }
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h4>Propietario:</h4>
                                        </th>
                                        <td>
                                            <span>{this.state.propietario}</span>
                                        </td>
                                    </tr>
                                    </tbody>
                                </Table>
                                <Row className="redesSociales">
                                    <Col md={{size: 2, offset: 3}} sm={{size: 2, offset: 3}} xs={{size: 2, offset: 3}}>
                                        <a href={(!!data_cultivo && !!data_cultivo[0].url_facebook)?data_cultivo[0].url_facebook:''} target="_blank">
                                            <img src={LogoFacebook} alt="Ver página en facebook"/>
                                        </a>
                                    </Col>
                                    <Col md={2} sm={2} xs={2}>
                                        <a href={(!!data_cultivo && !!data_cultivo[0].url_twitter)?data_cultivo[0].url_twitter:''} target="_blank">
                                            <img src={LogoTwitter} alt="Ver perfil en twitter"/>
                                        </a>
                                    </Col>
                                    <Col md={2} sm={2} xs={2}>
                                        <a href={(correo !== null) ? correo : ''}>
                                            <img src={LogoCorreo} alt="Enviar por correo"/>
                                        </a>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    }
                </Container>
            </div>

        );

    }
}

const mapStateToProps = state => {
    return {
        data_cultivo: state.cultivo.data_cultivo,
        is_loading: state.cultivo.is_loading,
        error: state.cultivo.error
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getCultivo: () => {
            return dispatch(cultivo.getCultivo());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);